<template>
    <div>
        <div id="inviteTeachersModal" class="modal">
            <div class="modal-contents">
                <span class="close" @click="inviteClose()">&times;</span>
                <div class="update-course">
                    <div class="modal-heading">
                        <h1 class="main-heading">Invite Teachers</h1>
                    </div>
                    <ul class="nav nav-tabs nav-padd-20">
                        <li class="active"><a data-toggle="tab" href="#t_email_invite">Email Invitation</a></li>
                        <li><a data-toggle="tab" href="#t_bulk_invite">Bulk Email Invitation</a></li>
                    </ul>
                    <div class="tab-content">
                        <div id="t_email_invite" class="tab-pane fade in active">
                            <div class="update-cour invite-main">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form id="invite-teachers-individually"
                                              @submit.prevent="inviteTeachersIndividually($event)">
                                            <div class="row">
                                                <div class="col-md-10 col-md-offset-1 t-invitation-main">
                                                    <div class="row t-invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
<!--                                                                <label class="ep-input-label">Name</label>-->
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row t-invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                        <div class="remove-elem"><i class="fa fa-times"></i></div>
                                                    </div>
                                                    <div class="row t-invitation-inner-main">
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_name"
                                                                       placeholder="Name">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="text"
                                                                       class="form-control dash-input add_invitation_email"
                                                                       placeholder="Email">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <div class="form-group">
                                                                <input type="number"
                                                                       class="form-control dash-input add_invitation_phone"
                                                                       placeholder="Phone">
                                                            </div>
                                                        </div>
                                                        <div class="remove-elem"><i class="fa fa-times"></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-10 col-md-offset-1">
                                                <a href="javascript:;" class="add-more-main" @click="addMoreElem()">
                                                    <i class="far fa-plus-square"></i> Add More
                                                </a>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <div class="form-group">
                                                    <button type="submit" class="ss-button">Invite</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="t_bulk_invite" class="tab-pane fade">
                            <div class="update-cour invite-main">
                                <div class="row">
                                    <div class="col-md-8 col-md-offset-2">
                                        <div class="form-group">
                                            <label class="ep-input-label float-left">Enter Emails</label>
                                            <textarea cols="7" class="form-control dash-input"
                                                      placeholder="Enter Emails exp: abc@gmail.com, pqr@gmail.com"
                                                      v-model="tEmails"></textarea>
                                            <div v-html="tEmailsError" class="form-text text-muted"></div>
                                        </div>
                                        <div class="col-md-12 text-center">
                                            <div class="form-group">
                                                <button type="button" class="ss-button margin-top-0"
                                                        @click="submitMultipleTeachers()">Invite
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from '../../public/js/toastr.js';
    import axios from 'axios';
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                tEmails: '',
                tEmailsError: '',
                file: '',
                t_file_name: 'Upload File Here',
                tData: '',
                tFileEmailsError: '',
                t_inviteTemplate: `<div class="row t-invitation-inner-main text-left" style="position: relative;"><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_name" placeholder="Name"></div></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_email" placeholder="Email"></div></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control dash-input add_invitation_phone" placeholder="Phone"></div></div><div class="remove-elem" style="position: absolute;right: -10px;cursor: pointer;top: 50%;color: #00a0e3;"><i class="fa fa-times"></i> </div></div>`,
            }
        },
        mounted() {
            this.initializeValidation();
        },
        methods: {
            inviteClose() {
                $('#inviteTeachersModal').modal('hide');
            },
            inviteTeachersIndividually() {
                var t = this;
                var validateErrors = $('.formHasError');
                if (validateErrors.length) {
                    return false;
                }
                var elems = document.querySelectorAll('.t-invitation-inner-main');
                if (elems[0].querySelector('.add_invitation_email').value == "") {
                    elems[0].childNodes[1].childNodes[0].insertAdjacentHTML("beforeend", '<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                    return false;
                }
                for (var i = 0; i < elems.length; i++) {
                    var name = elems[i].querySelector('.add_invitation_name').value;
                    var email = elems[i].querySelector('.add_invitation_email').value;
                    var phone = elems[i].querySelector('.add_invitation_phone').value;
                    if (name != "" || phone != "") {
                        if (email == "") {
                            elems[i].childNodes[1].childNodes[0].insertAdjacentHTML("beforeend", '<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                            return false;
                        }
                    }
                }
                var result = [];
                for (var j = 0; j < elems.length; j++) {
                    var r = {};
                    var i_name = elems[j].querySelector('.add_invitation_name').value;
                    var i_email = elems[j].querySelector('.add_invitation_email').value;
                    var i_phone = elems[j].querySelector('.add_invitation_phone').value;
                    if (i_email != "") {
                        r['name'] = i_name;
                        r['email'] = i_email;
                        r['phone'] = i_phone;
                        result.push(r);
                    }
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/teacher-invitation`, {
                    data: result,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Invitation Send', 'Success');
                            for (var i = 0; i < elems.length; i++) {
                                elems[i].querySelector('.add_invitation_name').value = "";
                                elems[i].querySelector('.add_invitation_email').value = "";
                                elems[i].querySelector('.add_invitation_phone').value = "";
                            }
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            submitMultipleTeachers() {
                var t = this;
                var mail_er = [];
                var imails = [];
                t.tEmailsError = '';
                if (t.tEmails == "") {
                    t.tEmailsError = "Emails cannot be blank.";
                    return false;
                }
                var mails = t.tEmails;
                mails = mails.trim().split(',');

                for (var i = 0; i < mails.length; i++) {
                    if (this.validateEmail(mails[i].trim())) {
                        imails.push(mails[i].trim());
                    } else {
                        mail_er.push(mails[i].trim());
                    }
                }

                if (imails.length == 0) {
                    t.tEmailsError = 'please enter correct emails';
                    return false;
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/teachers-invitation`, {
                    emails: imails,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res.status == 200) {
                            // var course = res['data']['response']['courses'];
                            toastr.success('Invitation Send', 'Success');
                            t.tEmails = '';
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            validateEmail(email) {
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (reg.test(email) == false) {
                    return false;
                }
                return true;
            },
            validatePhone(phone) {
                if (phone != "") {
                    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    if (phoneno.test(phone) == false) {
                        return false;
                    }
                }
                return true;
            },
            addMoreElem() {
                var elem_main = document.getElementsByClassName('t-invitation-main');
                elem_main[0].insertAdjacentHTML("beforeend", this.t_inviteTemplate);
                this.initializeValidation();
            },
            initializeValidation: function () {
                var t = this;
                $(document).on('blur', '.add_invitation_phone', function (e) {
                    e.preventDefault();
                    var phone_val = $(this).val();
                    var has_error = $(this).parent().children('p');
                    if (t.validatePhone(phone_val)) {
                        if (has_error.length) {
                            has_error.remove();
                        }
                    } else {
                        if (!has_error.length) {
                            $(this).parent().append('<p class="formHasError" style="color: #e40000;">Enter Valid Phone</p>')
                        }
                    }
                });
                $(document).on('blur', '.add_invitation_email', function (e) {
                    e.preventDefault();
                    var email_val = $(this).val();
                    var has_error = $(this).parent().children('p');
                    if (t.validateEmail(email_val)) {
                        if (has_error.length) {
                            has_error.remove();
                        }
                    } else {
                        if (!has_error.length) {
                            $(this).parent().append('<p class="formHasError" style="color: #e40000;">Enter Valid Email</p>')
                        }
                    }
                });
                $(document).on('click', '.remove-elem', function (e) {
                    e.preventDefault();
                    $(this).parent().remove();
                });
                $('.add_invitation_email, .add_invitation_phone, .add_invitation_name').on('keypress', function (e) {
                    if (e.which == 13) {
                        e.preventDefault();
                        return false
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .modal-contents {
        overflow: hidden !important;
        position: relative;
        background-color: #fff;
        overflow-y: scroll !important;
    }

    .modal-heading {
        text-align: center;
        padding: 10px;
    }

    .invite-main {
        max-width: 700px;
        margin: 0 auto;
    }

    .ss-button {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .ss-button:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }

    #invite-teachers-individually label, .float-left {
        float: left;
    }

    textarea.dash-input {
        height: 150px;
    }

    .margin-top-0 {
        margin-top: 0px;
    }

    .border-right-1px {
        border-right: 1px solid #eee;
    }

    .file-input {
        height: 0px;
        visibility: hidden;
    }

    .file-dropable {
        width: 100%;
        height: 150px;
        border: 1px dashed #eee;
        cursor: pointer;
        padding: 40px;
        text-align: center;
    }

    .file-dropable i {
        font-size: 34px;
    }

    .nav-tabs > li {
        text-align: center;
        margin-bottom: -1px;
        float: none;
        display: inline-block;
    }

    .nav-tabs li.active a {
        border: 0px !important;
    }

    .nav-tabs > li > a {
        border-radius: 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 12px;
        padding: 12px 20px;
        margin-right: 0;
        background-color: #fff;
        color: #222;
    }

    /*----tabs----*/
    .nav-tabs > li.active a, .nav-tabs > li.active a:hover, .nav-tabs > li.active a:focus {
        color: #fff;
        background-color: #00a0e3;
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        transition: .2s all;
    }

    .nav-tabs > li > a:hover {
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        color: #00a0e3;
    }

    .nav-tabs, .nav-tabs > li > a, .nav-tabs > li > a:hover {
        border: none;
    }

    ul.nav.nav-tabs.nav-padd-20 {
        text-align: center;
        margin-bottom: 20px;
    }

    /*----tabs end----*/
    .remove-elem {
        position: absolute;
        right: -10px;
        cursor: pointer;
        top: 50%;
        color: #00a0e3;
    }

    .t-invitation-inner-main {
        position: relative;
    }
</style>